import React from 'react'

/**
 * Ícones compartilhados entre dobras — paths do Tabler Icons (tabler.io/icons,
 * MIT), grid 24×24, stroke 2px, as mesmas junções e pontas do conjunto que já
 * vive em SecaoPalco.jsx.
 *
 * Aqui, e não lá dentro, porque estes quatro são a ASSINATURA da Rota (o
 * rodapé "Menos atrito · Mais clareza · Mais eficiência · Melhores
 * resultados." que aparece em toda peça física do evento) e reaparecem em mais
 * de uma dobra. Continuam inline em vez de pacote npm pelo mesmo motivo de
 * sempre: são poucos ícones e a lib inteira pesaria centenas de KB.
 */

const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
}

/** Alvo concêntrico — "menos atrito": mira que não escorrega. */
export function IconeAlvo(props) {
  return (
    <svg {...base} {...props}>
      <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
      <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
      <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
    </svg>
  )
}

/** Balão de conversa — "mais clareza". */
export function IconeConversa(props) {
  return (
    <svg {...base} {...props}>
      <path d="M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1" />
    </svg>
  )
}

/** Calculadora — "mais eficiência" (a conta que fecha sozinha). */
export function IconeCalculadora(props) {
  return (
    <svg {...base} {...props}>
      <path d="M4 3m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z" />
      <path d="M8 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z" />
      <path d="M8 14l0 .01" />
      <path d="M12 14l0 .01" />
      <path d="M16 14l0 .01" />
      <path d="M8 17l0 .01" />
      <path d="M12 17l0 .01" />
      <path d="M16 17l0 .01" />
    </svg>
  )
}

/** Barras crescentes — "melhores resultados". */
export function IconeBarras(props) {
  return (
    <svg {...base} {...props}>
      <path d="M3 13a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z" />
      <path d="M15 9a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z" />
      <path d="M9 5a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z" />
      <path d="M4 20h14" />
    </svg>
  )
}

/** Bandeirinha de chegada — usada nas peças de "linha de partida" do evento. */
export function IconeBandeira(props) {
  return (
    <svg {...base} {...props}>
      <path d="M5 21v-16" />
      <path d="M5 5l7 0l-1 3l1 3l-7 0" />
      <path d="M12 5l7 0l-1 3l1 3l-7 0" />
    </svg>
  )
}

/** Raio — automação: o que acontece sozinho. */
export function IconeRaio(props) {
  return (
    <svg {...base} {...props}>
      <path d="M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11" />
    </svg>
  )
}

/** Megafone — marketing e geração de demanda. */
export function IconeMegafone(props) {
  return (
    <svg {...base} {...props}>
      <path d="M18 8a3 3 0 0 1 0 6" />
      <path d="M10 8v11a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-5" />
      <path d="M12 8h0l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8" />
    </svg>
  )
}

/** Chave — locação: contrato, vistoria, entrega. */
export function IconeChave(props) {
  return (
    <svg {...base} {...props}>
      <path d="M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z" />
      <path d="M15 9h.01" />
    </svg>
  )
}

/** Engrenagem — processos internos. */
export function IconeEngrenagem(props) {
  return (
    <svg {...base} {...props}>
      <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
      <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
    </svg>
  )
}

/** Cofre/banco — ApBank e financeiro. */
export function IconeBanco(props) {
  return (
    <svg {...base} {...props}>
      <path d="M3 21l18 0" />
      <path d="M3 10l18 0" />
      <path d="M5 6l7 -3l7 3" />
      <path d="M4 10l0 11" />
      <path d="M20 10l0 11" />
      <path d="M8 14l0 3" />
      <path d="M12 14l0 3" />
      <path d="M16 14l0 3" />
    </svg>
  )
}
